module.exports = __webpack_public_path__ + "static/media/like.95356393.gif";